export const ru = {
  // Главная | Main
  totalBalance: 'Общий баланс',
  profit: 'Прибыль',
  convert: 'Конвертировать',
  balance: 'Баланс',
  foxBalance: 'Баланс {tokenName}',
  exchange: 'Обменять',
  deposit: 'Пополнить',
  withdraw: 'Вывести',
  arbitrageHistory: 'История арбитражных операций',
  spread: 'Спред',
  
  // Уведомления | Notifications
  notifications: 'Уведомления',
  automaticTradeExecuted: 'Автоматическая сделка выполнена',
  automaticTradeExecutedDesc: 'Выполнена автоматическая арбитражная сделка {pair} между {exchange1} и {exchange2}. Прибыль: ${profit}.',
  autoArbitrageStarted: 'Автоторговля запущена',
  autoArbitrageStartedDesc: 'Автоторговля активирована для {pairs} валютных пар. Планируется выполнить {trades} сделок.',
  autoArbitrageStopped: 'Автоторговля остановлена',
  autoArbitrageStoppedDesc: 'Автоторговля была остановлена пользователем.',
  autoArbitrageCompleted: 'Автоторговля завершена',
  autoArbitrageCompletedDesc: 'Все запланированные сделки ({trades}) успешно выполнены. Прибыль: ${profit}.',
  
  // Настройки | Settings
  settings: 'Настройки',
  display: 'ОТОБРАЖЕНИЕ',
  fullscreenMode: 'Полноэкранный режим',
  fullscreenModeDesc: 'Использовать весь экран для лучшего опыта',
  supportContact: 'Если у вас есть вопросы или проблемы, свяжитесь с нашей службой поддержки.',
  information: 'Информация',
  visitOfficialWebsite: 'Посетите наши ресурсы для получения дополнительной информации и обновлений.',
  technicalSupport: 'Тех. поддержка',
  
  // Транзакции | Transactions
  transactionHistory: 'История транзакций',
  withdrawProfit: 'Вывести прибыль',
  all: 'Все',
  deposits: 'Пополнение',
  withdrawals: 'Выводы',
  licenses: 'Лицензии',
  upgrades: 'Улучшения',
  reinvest: 'Реинвест',
  referral: 'Реферальные',
  status: 'Статус',
  withdrawal: 'Вывод',
  
  // Арбитраж | Arbitrage
  balanceAndLimits: 'Баланс и лимиты',
  availableTrades: 'Доступных сделок',
  chooseTradeMode: 'Выберите режим сделок',
  manual: 'Ручной',
  refreshTrades: 'Обновить сделки',
  available: 'Доступно',
  signalInactive: 'Сигнал не активен',
  buyPrices: 'Цены покупки',
  bestConditions: 'Лучшие условия',
  buyOn: 'Покупка на',
  sellOn: 'Продажа на',
  start: 'Начать',
  automatic: 'Автоматический',
  autoTradingSettings: 'Настройки автоторговли',
  currencyPairs: 'Валютные пары',
  selectedPairs: 'Выбрано: {count} пар',
  selectedPair: 'Выбрано: {count} пара',
  selectedPairsPlural: 'Выбрано: {count} пары',
  numberOfTrades: 'Количество сделок',
  spreadRange: 'Диапазон спреда',
  from: 'От',
  to: 'До',
  spreadRangeDesc: 'Автоторговля будет искать возможности с спредом в указанном диапазоне',
  amountPerTrade: 'Сумма для каждой сделки ($)',
  amountPerTradeValue: 'Сумма для каждой сделки: ${amount}',
  startAutoArbitrage: 'Запустить автоторговлю',
  starting: 'Запуск...',
  checkCurrentSessionStatus: 'Проверить статус текущей сессии',
  checking: 'Проверка...',
  refreshStatus: 'Обновить статус',
  autoTradingParameters: 'Параметры автоторговли',
  automationAmount: 'Сумма в автоматизации',
  targetProfit: 'Плановая прибыль',
  executionConditions: 'Условия выполнения',
  tradesRemaining: 'Осталось сделок',
  autoArbitrageActive: 'Автоторговля активна. Система автоматически ищет и выполняет арбитражные возможности',
  stopAutoArbitrage: 'Остановить автоторговлю',
  stopping: 'Остановка...',
  completed: 'Завершена',
  results: 'Результаты',
  totalProfit: 'Общая прибыль',
  averageProfitPerTrade: 'Средняя прибыль за сделку',
  autoTradingCompletedDesc: 'Автоторговля завершена! Выполнено {executed} из {total} сделок.\nВы можете просмотреть статистику и запустить новую сессию.',
  startNewSession: 'Запустить новую сессию',
  
  // Лицензии | Licenses
  currentLicense: 'Текущая лицензия',
  perDay: 'в день',
  licensesAndFeatures: 'Лицензии и возможности',
  tradeVolume: 'Объём сделки',
  buy: 'Купить',
  purchased: 'Куплена',
  insufficientFunds: 'Недостаточно средств',
  needToTopUp: 'Необходимо пополнить баланс на {amount} USDT',
  
  // Реферальная | Referral
  yourReferralLink: 'Ваша реферальная ссылка',
  referralStatistics: 'Статистика рефералов',
  numberOfActiveReferrals: 'Количество активных рефералов',
  totalReferralDeposits: 'Общий депозит рефералов',
  totalArbitrageProfit: 'Общая прибыль от арбитража',
  myReferrals: 'Мои рефералы',
  level1: '1 уровень',
  level2: '2 уровень',
  level3: '3 уровень',
  level4: '4 уровень',
  level5: '5 уровень',
  quantity: 'Количество',
  
  // Баланс на биржах | Exchange Balance
  exchangeBalance: 'Баланс на биржах',
  connectExchange: 'Подключить биржу',
  selectExchange: 'Выберите биржу',
  apiKey: 'API ключ',
  privateKey: 'Приватный ключ',
  secretWord: 'Секретное слово',
  enterApiKey: 'Введите API ключ',
  enterPrivateKey: 'Введите приватный ключ',
  enterSecretWord: 'Введите секретное слово',
  connect: 'Подключиться',
  connecting: 'Подключение...',
  fillAllFields: 'Заполните все поля',
  secretWordRequired: 'Секретное слово обязательно для этой биржи',
  connectionFailed: 'Ошибка подключения к бирже',
  howToGetApiKey: 'Как получить API ключ?',
  apiDocumentation: 'Документация API',

  // Управление биржами | Exchange Management
  exchangeManagement: 'Управление биржами',
  exchangeManagementDescription: 'Подключайте биржи, просматривайте балансы и управляйте API ключами',
  connectedExchanges: 'Подключенные биржи',
  addExchange: 'Добавить биржу',
  noExchangesConnected: 'Биржи не подключены',
  noExchangesDescription: 'Подключите свою первую биржу для просмотра балансов и автоматической торговли',
  connectFirstExchange: 'Подключить первую биржу',
  connected: 'Подключено',
  connectionError: 'Ошибка подключения',
  disconnected: 'Отключено',
  lastUpdate: 'Последнее обновление',
  balances: 'Балансы',
  summary: 'Сводка',
  totalExchanges: 'Всего подключенных бирж',
  connectedCount: 'Подключено',
  totalBalanceAllExchanges: 'Общий баланс всех бирж',
  loadExchangesError: 'Ошибка загрузки списка бирж',
  disconnectExchangeError: 'Ошибка отключения биржи',

  // Общие | Common
  language: 'Язык',
  russian: 'Русский',
  english: 'English',
  cancel: 'Отмена',
  confirm: 'Подтвердить',
  close: 'Закрыть',
  save: 'Сохранить',
  loading: 'Загрузка...',
  error: 'Ошибка',
  success: 'Успешно',
  warning: 'Предупреждение',
  info: 'Информация',
  update: 'Обновить',
  
  // Формы | Forms
  amount: 'Сумма',
  currency: 'Валюта',
  address: 'Адрес',
  walletAddress: 'Адрес кошелька',
  enterAmount: 'Введите сумму',
  enterAddress: 'Введите адрес кошелька',
  processing: 'Обработка...',
  
  // Модальные окна | Modals
  depositModal: 'Пополнение',
  withdrawModal: 'Вывод прибыли',
  availableForWithdraw: 'Доступно для вывода',
  amountToWithdraw: 'Сумма для вывода',
  minimumWithdrawal: 'Минимальный вывод',
  
  // История | History
  loadingHistory: 'Загрузка истории операций...',
  historyError: 'Не удалось загрузить историю операций',
  retry: 'Повторить',
  noArbitrageOperations: 'У вас пока нет арбитражных операций',
  date: 'Дата',
  time: 'Время',
  
  // Навигация | Navigation
  dashboard: 'Главная',
  transactions: 'Транзакции',
  arbitrage: 'Арбитраж',
  referrals: 'Рефералы',
  admin: 'Админ',
  
  // Админ панель | Admin Panel
  adminDashboard: 'Панель администратора',
  adminTitle: 'Админ-панель',
  adminInfo: 'Администратор:',
  accessDeniedTitle: 'Доступ запрещен',
  accessDeniedDescription: 'У вас нет прав администратора',
  
  // Перенос рефералов | Referral Transfer
  referralTransfer: 'Перенос рефералов',
  referralTransferTitle: 'Перенос реферала',
  referralTransferDescription: 'Поставьте пользователя (по username) под нового реферера со всей его 5-уровневой структурой',
  usernameUser: 'Username пользователя',
  usernamePlaceholder: 'Введите username без @',
  usernameHint: 'Username пользователя, которого нужно перенести со всей его структурой',
  newReferrer: 'Новый реферер (username)',
  newReferrerPlaceholder: 'Введите username без @',
  newReferrerHint: 'Username пользователя, под которого нужно поставить',
  transferring: 'Переношу...',
  transferStructure: 'Перенести со структурой',
  transfer: 'Перенести',
  searchUsers: 'Поиск пользователей...',
  noUsersFound: 'Пользователи не найдены',
  
  // Управление выводами | Withdrawal Management
  withdrawalManagement: 'Управление выводами',
  withdrawalManagementTitle: 'Управление выводами',
  withdrawalManagementDescription: 'Одобряйте или отклоняйте заявки на вывод средств',
  activeWithdrawals: 'Активные выводы',
  loadingWithdrawals: 'Загрузка заявок...',
  noActiveWithdrawals: 'Нет активных заявок на вывод',
  approve: 'Подтвердить',
  reject: 'Отклонить',
  approved: 'Одобрено',
  confirmApproval: 'Подтверждение перевода',
  confirmRejection: 'Отклонение заявки',
  approvalQuestion: 'Вы действительно перевели деньги пользователю?',
  rejectionQuestion: 'Вы действительно хотите отклонить этот вывод? Деньги будут возвращены на баланс пользователя.',
  
  // Управление бонусами | Bonus Management
  bonusManagement: 'Управление бонусами',
  bonusManagementTitle: 'Выдача бонусов',
  bonusManagementDescription: 'Выдавайте бонусные деньги или дополнительные сделки пользователям',
  giveBonusMoney: 'Выдать бонусные деньги',
  giveBonusDeals: 'Выдать бонусные сделки',
  bonusMoney: 'Бонусные деньги',
  bonusDeals: 'Дополнительные сделки',
  username: 'Имя пользователя',
  bonusAmount: 'Сумма бонуса (USDT)',
  bonusAmountPlaceholder: 'Введите сумму',
  bonusDealsPlaceholder: 'Введите количество',
  giving: 'Выдаю...',
  giveBonus: 'Выдать бонус',
  give: 'Выдать',
  notSpecified: 'Не указан',
  
  // Статусы | Statuses
  pending: 'Ожидание',
  confirmed: 'Подтверждено',
  rejected: 'Отклонено',
  completed: 'Завершено',
  active: 'Активно',
  inactive: 'Неактивно',
  
  // Уведомления об успехе/ошибке | Success/Error notifications
  referralTransferSuccess: 'Реферал успешно перенесен',
  withdrawalApproved: 'Вывод одобрен',
  withdrawalRejected: 'Вывод отклонен',
  bonusMoneyGiven: 'Бонусные деньги выданы',
  bonusDealsGiven: 'Бонусные сделки выданы',
  operationFailed: 'Операция не удалась',
  fillAllFields: 'Заполните все поля',
  addressCopied: 'Адрес скопирован в буфер обмена',
  addressCopyFailed: 'Не удалось скопировать адрес',
  
  // Дополнительные тексты
  copyToClipboard: 'Скопировать в буфер обмена',
  copied: 'Скопировано!',
  clickToCopy: 'Нажмите для копирования',
  
  // Транзакции - страница | Transactions page
  topUp: 'Пополнить',
  transactionsNotFound: 'Транзакции не найдены',
  transactionLoadError: 'Ошибка при загрузке транзакций. Пожалуйста, попробуйте снова позже.',
  insufficientProfitForWithdrawal: 'Недостаточно прибыли для вывода',
  withdrawalRequestError: 'Ошибка при создании запроса на вывод',
  depositRequestError: 'Ошибка при создании запроса на пополнение',
  pay: 'Оплатить',
  amountToWithdrawLabel: 'Сумма для вывода',
  availableForWithdrawal: 'Доступно для вывода',
  depositAccountTitle: 'Пополнение счета',
  
  // Статусы транзакций | Transaction statuses
  inProcessing: 'В обработке',
  failed: 'Ошибка',
  
  // Типы транзакций | Transaction types
  topUpTransaction: 'Пополнение',
  withdrawalTransaction: 'Вывод',
  licensePurchase: 'Покупка лицензии',
  licenseUpgrade: 'Улучшение лицензии',
  reinvestment: 'Реинвестирование',
  referralCommission: 'Реферальная комиссия',
  foxConversionTransaction: 'Конвертация {tokenName}',
  profitConversionTransaction: 'Конвертация прибыли',
  
  // Фильтры транзакций | Transaction filters
  allTransactions: 'Все',
  depositsFilter: 'Пополнения',
  withdrawalsFilter: 'Выводы',
  licensesFilter: 'Лицензии',
  upgradesFilter: 'Улучшения',
  reinvestFilter: 'Реинвест',
  referralFilter: 'Реферальные',
  conversionsFilter: 'Конверсии',
  
  // Лицензии - страница | Licenses page
  numberOfDeals: 'Количество сделок',
  availableDeals: 'Доступно сделок',
  currentLicenseLabel: 'Текущая лицензия',
  licensesAndFeaturesTitle: 'Лицензии и возможности',
  numberOfDealsLabel: 'Количество сделок',
  maxTradeVolumeLabel: 'Объём сделки',
  maxTradeVolumeValue: 'max {amount} USDT',
  buyLicense: 'Купить',
  purchasedLicense: 'Куплена',
  insufficientFundsButton: 'Недостаточно средств',
  needToTopUpBalance: 'Необходимо пополнить баланс на {amount} USDT',
  purchaseConfirmationTitle: 'Подтверждение покупки',
  purchaseConfirmationMessage: 'Вы собираетесь приобрести лицензию {license} за {price} USDT',
  failedToPurchaseLicense: 'Failed to purchase license. Please try again.',
  
  // Рефералы - страница | Referrals page
  copiedNotification: 'Скопировано',
  failedToLoadReferralData: 'Не удалось загрузить данные о рефералах',
  yourReferralLinkLabel: 'Ваша реферальная ссылка',
  yourReferralsTurnover: 'Оборот ваших рефералов',
  yourReferralLevel: 'Ваш уровень реферала',
  referralStatsTitle: 'Статистика рефералов',
  numberOfActiveReferralsLabel: 'Количество активных рефералов',
  totalReferralDepositsLabel: 'Общий депозит рефералов',
  totalReferralBalanceLabel: 'Общий баланс рефералов',
  totalArbitrageProfitLabel: 'Общая прибыль от арбитража',
  myReferralsTitle: 'Мои рефералы',
  levelLabel: '{level} уровень',
  quantityLabel: 'Количество',
  depositLabel: 'Депозит',
  balanceLabel: 'Баланс',
  profitLabel: 'Прибыль',
  viewReferrals: 'Посмотреть рефералов',
  levelReferralsTitle: 'Рефералы {level} уровня',
  sortBy: 'Сортировка',
  registrationDate: 'Дата регистрации',
  depositAmount: 'Сумма депозита',
  profitAmount: 'Сумма прибыли',
  loadingReferrals: 'Загрузка рефералов...',
  nextPage: 'Следующая',
  previousPage: 'Предыдущая',
  pageInfo: 'Страница {current} из {total}',
  referralSystemConditionsTitle: 'Условия реферальной системы',
  referralSystemDescription: 'Просто поделись инструментом с друзьями - получай бонусы сделки и сниженные комиссиию Чем больше активность команды - тем больше привилегий для тебя',
  statusTableHeader: 'Статус',
  structureTurnoverTableHeader: 'Оборот структуры',
  partnersCountTableHeader: 'Количество партнеров',
  levelsDepthTableHeader: 'Глубина уровней',
  commissionReductionTableHeader: 'Снижение комиссии',
  bonusDealsTableHeader: 'Бонусные сделки за торговый объем партнеров (USDT)',
  maxDailyLimitTableHeader: 'Макс. суточный лимит бонусных сделок',
  
  // Арбитраж - страница | Arbitrage page
  balanceAndLimitsTitle: 'Баланс и лимиты',
  availableTradesLabel: 'Доступных сделок',
  chooseTradeModeTitle: 'Выберите режим сделок',
  manualMode: 'Ручной',
  automaticMode: 'Автоматический',
  refreshTradesButton: 'Обновить сделки',
  signalAvailable: '• Доступно',
  signalNotActive: '• Сигнал не активен',
  bestConditionsTitle: 'Лучшие условия',
  buyOnLabel: 'Покупка на',
  sellOnLabel: 'Продажа на',
  spreadLabel: 'Спред',
  startButton: 'Начать',
  
  // Автоторговля | Auto-trading
  autoTradingSettingsTitle: 'Настройки автоторговли',
  currencyPairsLabel: 'Валютные пары',
  numberOfTradesLabel: 'Количество сделок',
  enterNumberOfTrades: 'Введите количество сделок',
  spreadRangeLabel: 'Диапазон спреда (%)',
  fromLabel: 'От',
  toLabel: 'До',
  spreadRangeDescription: 'Автоторговля будет искать возможности с спредом в указанном диапазоне',
  amountPerTradeLabel: 'Сумма для каждой сделки ($)',
  startAutoTradingButton: 'Запустить автоторговлю',
  startingAutoTrading: 'Запуск...',
  checkingStatus: 'Проверка...',
  
  // Статусы автоторговли | Auto-trading statuses
  autoTradingActive: 'Автоторговля активна. Система автоматически ищет и выполняет арбитражные возможности...',
  autoTradingCompleted: 'Автоторговля завершена! Выполнено {completed} из {total} сделок. Вы можете просмотреть статистику и запустить новую сессию.',
  stopAutoTradingButton: 'Остановить автоторговлю',
  stoppingAutoTrading: 'Остановка...',
  statusCompleted: 'Завершена',
  statusActive: 'Активна',
  startNewSessionButton: 'Запустить новую сессию',
  
  // Этапы выполнения сделки | Trade execution steps
  connectingToExchange: 'Подключение к бирже',
  checkingLiquidity: 'Проверка ликвидности',
  buyingCoin: 'Покупка монеты',
  transferringCoin: 'Трансфер монеты',
  sellingCoins: 'Продажа монет',
  fixingProfit: 'Фиксация прибыли',
  
  // Сообщения об ошибках | Error messages
  insufficientBalanceForTrade: 'Недостаточно средств на балансе для выполнения одной сделки',
  insufficientBalanceForTradeExecution: 'Недостаточно средств на балансе для выполнения сделки',
  insufficientBalanceMessage: 'Недостаточно средств на балансе',
  insufficientBalanceDetailed: 'Недостаточно средств на балансе для одной сделки. Требуется: ${required}, доступно: ${available}',
  insufficientFundsNote: '(недостаточно средств)',
  minSpreadLowerThanMax: 'Минимальный спред должен быть меньше максимального',
  failedToSetupAutoTrading: 'Не удалось настроить автоматический трейдинг. Пожалуйста, попробуйте позже.',
  failedToRestartAutoTrading: 'Не удалось перезапустить автоматический трейдинг. Пожалуйста, попробуйте позже.',
  
  // Завершение сделки | Trade completion
  tradeCompletedTitle: 'Сделка завершена!',
  tradeCompletedMessage: 'Ваша арбитражная сделка по паре {pair} успешно завершена. Средства зачислены на баланс.',
  
  // Дополнительные переводы для Arbitrage | Additional Arbitrage translations
  errorRefreshingUserData: 'Не удалось обновить данные пользователя',
  errorFetchingArbitrageOpportunities: 'Не удалось загрузить арбитражные возможности. Пожалуйста, попробуйте позже.',
  minimumDealAmount: 'Минимальная сумма сделки:',
  maximumDealAmount: 'Максимальная сумма сделки:',
  failedToExecuteArbitrage: 'Не удалось выполнить арбитражную сделку. Пожалуйста, попробуйте позже.',
  enterAmount: 'Введите сумму',
  
  // Дополнительные UI элементы | Additional UI elements
  noArbitrageOpportunitiesMessage: 'Нет доступных арбитражных возможностей. Попробуйте обновить позже.',
  
  // Форма торговли | Trade form
  trade: 'Сделка',
  availableInDeposit: 'Доступно на депозите',
  minimumAmount: 'Минимальная сумма',
  maximumAmount: 'Максимальная сумма',
  next: 'Далее',
  
  // Выполнение сделки | Trade execution
  launchArbitrageTrade: 'Запуск арбитражной сделки',
  tradeParameters: 'Параметры сделки',
  pair: 'Пара',
  volume: 'Объём',
  expectedProfit: 'Ожидаемая прибыль',
  
  // Завершенная сделка | Completed trade
  tradeResults: 'Результаты сделки',
  currentBalance: 'Текущий баланс',
  platformCommission: 'Комиссия платформы',
  commissionTooltip: 'Чтобы снизить комиссию, приглашайте партнеров: чем больше партнеров, тем ниже комиссия!',
  commissionAmount: 'Сумма комиссии',
  done: 'Готово',
  
  // Автоторговля - дополнительные переводы | Auto-trading - additional translations
  tradesProgress: 'Прогресс сделок',
  selectedPairsCount: 'Выбрано: {count} пар',
  amountExceedsMaxDeal: 'Сумма для каждой сделки не может превышать ${maxAmount}',
  
  // Fox модальное окно | Fox modal
  getFoxTokens: 'Получить Fox токены',
  getFoxTokensDescription: 'Получите 10 Fox токенов для улучшения ваших торговых возможностей!',
  
  // Конвертация Fox токенов | Fox tokens conversion
  convertFoxTokens: 'Конвертация {tokenName} токенов',
  conversionRate: 'Курс конвертации',
  availableFoxBalance: 'Доступный баланс {tokenName}',
  foxAmountToConvert: 'Количество {tokenName} для конвертации',
  enterFoxAmount: 'Введите количество {tokenName}',
  minimumConversion: 'Минимальная конвертация',
  foxToConvert: 'К конвертации',
  usdtToReceive: 'К получению',
  converting: 'Конвертация...',
  convertButton: 'Конвертировать',
  minimumConversionAmount: 'Минимальная сумма конвертации 500 {tokenName}',
  insufficientFoxTokens: 'Недостаточно {tokenName} токенов',
  conversionFailed: 'Ошибка конвертации. Попробуйте позже.',
  foxConversion: 'Конвертация {tokenName}',
  swipeToConvert: 'Проведите для конвертации',
  releaseToConvert: 'Отпустите для конвертации',
  converted: 'Конвертировано',
  convertProfitToBalance: 'Конвертация прибыли в баланс',
  availableProfitBalance: 'Доступная прибыль',
  profitAmountToConvert: 'Сумма прибыли для конвертации',
  enterProfitAmount: 'Введите сумму прибыли',
  profitToConvert: 'К конвертации',
  balanceToReceive: 'К получению на баланс',
  swipeToConvertProfit: 'Проведите для конвертации прибыли',
  releaseToConvertProfit: 'Отпустите для конвертации прибыли',
  minimumProfitConversionAmount: 'Минимальная сумма конвертации 1 USDT',
  insufficientProfit: 'Недостаточно прибыли',
  profitConversionFailed: 'Ошибка конвертации прибыли. Попробуйте позже.',
  
  // Новые переводы для улучшенного UX
  noReferralsYet: 'У вас пока нет рефералов',
  noReferralsAtThisLevel: 'На этом уровне рефералов пока нет',
  
  // Детали сделки | Trade Details
  tradeDetails: 'Детали сделки',
  tradingPair: 'Торговая пара',
  exchanges: 'Биржи',
  financialDetails: 'Финансовые детали',
  tradeAmount: 'Сумма сделки',
  transactionSteps: 'Этапы транзакции',
  buyOrder: 'Ордер на покупку',
  sellOrder: 'Ордер на продажу',
  profitRealized: 'Прибыль получена',
  boughtOn: 'Куплено на',
  soldOn: 'Продано на',
  addedToBalance: 'добавлено к балансу',
  completed: 'Завершено',
  
  // Торговая активность | Trade Activity
}; 